import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import { formatBraceAttrs } from "@ext/markdown/logic/braceAttrs";
import { getFence } from "@ext/markdown/logic/fence";
import type { NodeSerializerSpec } from "../../../../core/edit/logic/Prosemirror/to_markdown";

const DiagramsFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	(state, node) => {
		const name = node.attrs.diagramName.toLowerCase();

		if (node.attrs.src) {
			const hasSize = node.attrs.width && node.attrs.height;
			const hasFloat = node.attrs.float;
			const hasScale = node.attrs.scale;
			state.write(
				formatter.openTag(
					name,
					{
						path: node.attrs.src,
						title: node.attrs.title,
						...(hasSize ? { width: node.attrs.width, height: node.attrs.height } : {}),
						...(hasFloat || hasScale ? { float: node.attrs.float ?? "" } : {}),
						...(hasScale ? { scale: node.attrs.scale } : {}),
					},
					true,
				),
			);
			state.closeBlock(node);
			return;
		}

		// The diagram lives in the article, so its markup lives in the info string: the language
		// stays the first word and GitHub still draws the block.
		const fence = getFence(node.attrs.content);
		const attrs = formatBraceAttrs({
			title: node.attrs.title,
			scale: node.attrs.scale,
			float: node.attrs.float,
		});

		state.write(`${fence}${name}${attrs ? ` ${attrs}` : ""}\n`);
		state.text(node.attrs.content, false);
		state.ensureNewLine();
		state.write(fence);
		state.closeBlock(node);
	};

export default DiagramsFormatter;
